import _extends from '@babel/runtime/helpers/extends';
import 'react';
import PropTypes from 'prop-types';
import { Container } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var FluidMaxContainer = function FluidMaxContainer(props) {
  return jsx(Container, _extends({
    px: 0
  }, props));
};
FluidMaxContainer.propTypes = {
  children: PropTypes.node
};
FluidMaxContainer.defaultProps = {
  children: null
};
export { FluidMaxContainer as default };